var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMscMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 130",
    role: "img",
    "aria-label": "Maximum Sports Conditioning",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1F2D55"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 42,
    width: 14,
    height: 36,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 8,
    height: 52,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 55,
    width: 28,
    height: 10,
    rx: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F2D55"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 42,
    width: 14,
    height: 36,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 34,
    width: 8,
    height: 52,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 55,
    width: 28,
    height: 10,
    rx: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#E60000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 14,
    width: 16,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 14,
    width: 16,
    height: 60
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92,14 120,50 148,14 148,30 120,66 92,30"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fontFamily: "'Bebas Neue', Impact, 'Oswald', system-ui, sans-serif",
    fontWeight: 700,
    letterSpacing: 3
  }, /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 98,
    textAnchor: "middle",
    fontSize: 14
  }, "MAXIMUM SPORTS"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 116,
    textAnchor: "middle",
    fontSize: 14
  }, "CONDITIONING"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMscMark);
export default __webpack_public_path__ + "static/media/logo-msc-mark.5c6667834de63ea146c689769bdadfd3.svg";
export { ForwardRef as ReactComponent };